/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import cx from 'classnames';
import * as React from 'react';

import type { TextInputProps } from '../../types';
import './TextInput.less';

const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({ size = 'medium', type = 'text', invalid = false, prefix, suffix, className, disabled, ...rest }, ref) => {
    return (
      <span
        className={cx(
          'text-input',
          `text-input--${size}`,
          {
            'text-input--invalid': invalid,
            'text-input--disabled': disabled,
            'text-input--has-prefix': !!prefix,
            'text-input--has-suffix': !!suffix,
          },
          className
        )}>
        {prefix && <span className="text-input__prefix">{prefix}</span>}
        <input ref={ref} type={type} disabled={disabled} className="text-input__field" {...rest} />
        {suffix && <span className="text-input__suffix">{suffix}</span>}
      </span>
    );
  }
);

TextInput.displayName = 'TextInput';

export default TextInput;
